/**
=========================================================
* Vue Argon Dashboard 2 PRO - v3.0.1
=========================================================

* Product Page: https://creative-tim.com/product/vue-argon-dashboard-pro
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { createApp } from 'vue';
import App from './App.vue';
import store from './store';
import router from './router';
import './assets/css/nucleo-icons.css';
import './assets/css/nucleo-svg.css';
import VueTilt from 'vue-tilt.js';
import VueSweetalert2 from 'vue-sweetalert2';
import ArgonDashboard from './argon-dashboard';
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import dayjs from 'dayjs';
import lodash from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import i18n from '@/i18n';
import Util from '@/common/utils/Util';
import ConstCode from '@/common/constants/ConstCode';
import ServiceExec from '@/common/utils/ServiceExec';
import '@fortawesome/fontawesome-free/css/all.css';

library.add(fas, fab, far);

const isBetween = require('dayjs/plugin/isBetween');
dayjs.extend(isBetween);

const app = createApp(App);
app.config.globalProperties.$_ = lodash;
app.config.globalProperties.$ConstCode = ConstCode;
app.config.globalProperties.$ServiceExec = ServiceExec;
app.config.globalProperties.$Util = Util;
app.config.globalProperties.$dayjs = dayjs;

app.component('font-awesome-icon', FontAwesomeIcon);

import { ObserveVisibility } from 'vue-observe-visibility';
app.directive('infinite', {
  beforeMount: (el, binding, vnode) => {
    vnode.context = binding.instance;
    ObserveVisibility.bind(el, binding, vnode);
  }
});

app.use(store);
app.use(router);
app.use(VueTilt);
app.use(VueSweetalert2);
app.use(ArgonDashboard);
app.use(ElementPlus);
app.use(i18n);
app.mount('#app');
